import { Injectable, EventEmitter } from "@angular/core";
import { DIMBO_CONSTANT } from './../utils/constant';
//import *  as  data from './../../assets/i18n/en-GB.json';
import *  as  data from './../../assets/i18n/en.json';

@Injectable()
export class TranslationService {

    private translationValues: any = {};

    /* constructor() {
        this.translationValues = (data as any).default;
    } */

    constructor() {
      this.translationValues = (data as any).default;
      // Load the default language for the application
      /* const i18nLocale = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_I18N_LOCALE);
      const i18nValues = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_I18N_DATA);
      if (!i18nLocale) {
          this.loadTranlationForLocale(DIMBO_CONSTANT.DEFAULT_LOCALE);
      }
      if (i18nValues) {
          this.translationValues = i18nValues;
      }

      setTimeout(() => {
          let currentUrl = window.location.href.split('?')[0].split('/#')[1];
          if (currentUrl === '/') {
              this.event.emit({ languageCode: this.cacheService.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE) });
          }
      }, 1000); */
  }

    /*translate value*/
    public translate(key: string): string {
        let value: string = '';
        if (key && this.translationValues && this.translationValues[key]) {
            value = this.translationValues[key];
        }
        return value;
    }

}